import {
  type BlocksContent,
  BlocksRenderer,
} from '@strapi/blocks-react-renderer'
import { type ReactQuery } from 'cms-api'

import { rem } from 'polished'
import React from 'react'
import { Box, Container, Flex, Grid } from 'components/Layout'
import { StyledLink } from 'components/Link'
import { Text } from 'components/Typography'

import { COLOR_NAMES, FONT_SIZE, FONT_STACK, FONT_WEIGHT, SPACE } from 'Theme'
import { StrapiTrendingProductsProduct } from './StrapiTrendingProductsProduct'

export const StrapiTrendingProductsWidget: React.FC<
  React.PWC<ReactQuery.WidgetsTrendingProductsWidgetComponent>
> = ({ title, buttonText, buttonLink, products }) => (
  <Box
    pb={{ MOBILE: SPACE.PX_48, TABLET: rem(66) }}
    pt={{ MOBILE: SPACE.PX_64, TABLET: rem(66) }}
  >
    <Container>
      <Flex justifyContent="center" flexDirection="column" alignItems="center">
        {title && (
          <Box>
            <BlocksRenderer
              content={title as BlocksContent}
              blocks={{
                paragraph: ({ children }) => (
                  <Text
                    as="h1"
                    fontSize={{
                      MOBILE: FONT_SIZE.PX_24,
                      TABLET: rem(40),
                    }}
                    color={COLOR_NAMES.PINEY_LAKE}
                    fontWeight={FONT_WEIGHT.NORMAL}
                    my={SPACE.PX_12}
                    textAlign="center"
                    fontFamily={FONT_STACK.SERIF}
                    lineHeight="140%"
                  >
                    {children}
                  </Text>
                ),
              }}
            />
          </Box>
        )}
      </Flex>
      {products && products.length > 0 && (
        <Grid
          gridTemplateColumns={{
            MOBILE: '1fr 1fr',
            TABLET: 'repeat(3, 1fr)',
            DESKTOP: 'repeat(4, 1fr)',
          }}
          gridGap={{ MOBILE: SPACE.PX_16, TABLET: SPACE.PX_32 }}
        >
          {products.map(({ product }) => (
            <StrapiTrendingProductsProduct
              key={product.id}
              // @ts-ignore - TODO: fix typings
              product={product}
            />
          ))}
        </Grid>
      )}
      {buttonLink && buttonText && (
        <Flex width="100%" justifyContent="center" mt={SPACE.PX_40}>
          <StyledLink href={buttonLink} aria-label={buttonText}>
            {buttonText}
          </StyledLink>
        </Flex>
      )}
    </Container>
  </Box>
)
